<template>
  <div class="components-container">
    <header>
      <span class="title">试用客户</span>
      <div class="right">
        <el-input class="seach" size="small" v-model="searchInput" placeholder="请输入内容" suffix-icon="el-icon-search" @keyup.enter.native="search"></el-input>
        <el-dropdown @command="handleCommand"  trigger="click">
          <el-button>批量修改<i class="el-icon-arrow-down el-icon--right"></i></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item  command="0" :disabled="disabled">功能版本</el-dropdown-item>
            <el-dropdown-item  command="1" :disabled="disabled">组件版本</el-dropdown-item>
            <el-dropdown-item  command="2" :disabled="disabled">使用人数</el-dropdown-item>
            <el-dropdown-item  command="3" :disabled="disabled">启用</el-dropdown-item>
            <el-dropdown-item  command="4" :disabled="disabled">禁用</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="primary" @click="AddDialog" v-if="funAuth.includes(4)">新 增</el-button>
      </div>
    </header>
    <el-table class="el-table-01" :data='tableList' style='width: 100%' @selection-change='handleSelectionChange' @row-click="rowClick">
      <el-table-column type='selection' width='55'></el-table-column>
      <el-table-column prop='company_no' label='公司编号' min-width='160'></el-table-column>
      <el-table-column prop='company_name' label='公司名称' min-width='260'></el-table-column>
      <el-table-column prop='deployment_type' label='部署方式' min-width='140'>
        <template slot-scope='scope'>
          {{(scope.row.deployment_type === '1') ? '本地初始化':'云服务初始化'}}
        </template>
      </el-table-column>
      <el-table-column prop='user_name' label='客户姓名' min-width='140' :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop='phone' label='联系电话' min-width='160' :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label='账号状态' min-width='100'>
        <template slot-scope='scope'>{{ scope.row.status == 0 ? '启用' : '禁用'}}</template>
      </el-table-column>
      <el-table-column label='开通版本' min-width='140'>
        <template slot-scope='scope'>
          <span v-text="editionInit(scope.row.edition)"></span>
        </template>
      </el-table-column>
      <el-table-column prop='allow_number' label='开通坐席' min-width='100'></el-table-column>
      <el-table-column label='套餐开始时间' min-width='140'>
        <template slot-scope='scope'>{{ scope.row.start_time | formatDate('yyyy-MM-dd') }}</template>
      </el-table-column>
      <el-table-column label='套餐结束始时间' min-width='140'>
        <template slot-scope='scope'>{{ scope.row.end_time | formatDate('yyyy-MM-dd') }}</template>
      </el-table-column>
      <el-table-column label='附件空间' min-width='120'>
        <template slot-scope='scope'>{{scope.row.attachment_size}}GB</template>
      </el-table-column>
      <el-table-column prop='data_size' label='总数据量' min-width='120'>
        <template slot-scope='scope'>{{scope.row.data_size}}条</template>
      </el-table-column>
      <el-table-column prop='internal_account' label='内部帐户' min-width='100'>
        <template slot-scope='scope'>{{scope.row.internal_account==1?'否':'是'}}</template>
      </el-table-column>
      <el-table-column prop='invite_code' label='邀请码' min-width='100'></el-table-column>
      <el-table-column prop='customer_name' label='维护客服' min-width='100'></el-table-column>
      <el-table-column prop='create_by' label='创建人' min-width='100'></el-table-column>
      <el-table-column label='创建时间' min-width='180'>
        <template slot-scope='scope'>{{ scope.row.create_time | formatDate('yyyy-MM-dd HH:mm') }}</template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page='pageNum' :page-sizes='[10, 20, 50, 100]' :page-size='pageSize' layout='total, sizes, prev, pager, next, jumper' :total='tableTotal'></el-pagination>

    <div class="mask n2" v-if="dialogCusDetail" @click="dialogCusDetail = false"></div>
    <transition name="slide">
      <trial-detail v-if="dialogCusDetail" :customer="customerDetail"></trial-detail>
    </transition>
    <div class="mask n1" v-if="dialogAdd" @click="dialogAdd = false"></div>
    <transition name="slide">
      <customer-add v-if="dialogAdd" :customer="customerDetail"></customer-add>
    </transition>

    <el-dialog title="批量修改" :visible.sync="batchDialog" class="dialog-manage">
      <div class="c-item">
        <span class="title must" style="width: 90px">批量修改为</span>
        <div class="right" v-if="command==0">
          <el-select v-model="batchValue" placeholder="请选择(必填)" size="medium">
            <el-option v-for="item in vOptions" :key="item.id" :label="item.version_name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="right" v-if="command==1">
          <el-select v-model="batchValue" placeholder="请选择(必填)" size="medium">
            <el-option v-for="item in componentData" :key="item.id" :label="item.cm_name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="right" v-if="command==2">
          <el-input v-model="batchValue" placeholder="请输入(必填)" size="medium" type="number"></el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchDialog = false">取 消</el-button>
        <el-button type="primary" @click="batchSave">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="提示" :visible.sync="dialogStatus" class="prompt-box" append-to-body>
      <i class="iconfont icon-prompt-box"></i>
      <div class="content">{{(command == 4) ? '停用':'启用'}}</div>
      <div class="note" v-if="command == 4">停用后该客户里的所有账号将不允许登录和使用系统。</div>
      <div style="margin-top: 20px;" v-else></div>
      <div class="prompt">{{(command == 4) ? '你确定要停用所选的公司账号吗？':'你确定要启用所选的公司账号吗？'}}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogStatus = false">取 消</el-button>
        <el-button type="primary" @click="batchSave">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {HTTPServer} from '@/common/js/ajax.js'
import customerAdd from '@/common/components/customer-add'// 新增
import featureList from '@/common/components/feature-list'// 功能清单
import trialDetail from '@/common/components/trial-detail'// 试用客户详情
import mixin from '@/common/js/mixins.js'

export default {
  data () {
    return {
      defaultMsg: '<b>试用客户</b>',
      searchInput: '',
      tableList: [],
      pageSize: 20,
      moduleId: 1,
      pageNum: 1,
      tableTotal: 0,
      dialogDelete: false,
      disabled: true,
      dialogCusDetail: false,
      customerDetail: {},
      dialogAdd: false,
      transferOfficer: null,
      userList: [],
      batchValue: '',
      command: '',
      componentData: [],
      batchDialog: false, // 批量修改
      dialogStatus: false
    }
  },
  mixins: [mixin],
  mounted () {
    this.queryTrialUserList()
    this.queryAllChargingStrategy()
    this.queryFchBtnAuth(({moduleId: this.moduleId}))
    // 关闭添加窗口
    this.$bus.on('closeAddModal', (value) => {
      if (value) {
        this.dialogAdd = false
      }
    })
    // 关闭添加窗口
    this.$bus.on('close-trial-detail', (value) => {
      if (value) {
        this.dialogCusDetail = false
      }
    })
    /** 添加、编辑客户 */
    this.$bus.off('saveAddModal')
    this.$bus.on('saveAddModal', (jsondata, type) => {
      if (type === 1) {
        this.saveTrialUser(jsondata)
      }
    })

    this.$bus.off('query-trial-list')
    this.$bus.on('query-trial-list', (value, page) => {
      if (value) {
        if (page) {
          this.pageNum2 = 1
        }
        this.queryTrialUserList()
      }
    })
  },
  components: {
    customerAdd,
    featureList,
    trialDetail
  },
  methods: {
    handleCommand (cmd) {
      console.log(typeof cmd, cmd)
      this.command = cmd
      this.batchValue = ''
      if (cmd === '0') {
        this.queryAllChargingStrategy()
        this.batchDialog = true
      } else if (cmd === '1') {
        this.getComponentManageList()
        this.batchDialog = true
      } else if (cmd === '2') {
        this.batchDialog = true
      } else if (cmd === '3') {
        this.dialogStatus = true
      } else if (cmd === '4') {
        this.dialogStatus = true
      }
    },
    // 批量保存
    batchSave () {
      let arr = []
      this.multipleSelection.map(v => {
        arr.push(v.company_id)
      })
      let jsondata = {
        ids: arr.toString(),
        type: this.command,
        value: this.batchValue
      }
      if (this.command === '0' || this.command === '1') {
        if (!this.batchValue) {
          this.$message.error('修改值不能为空!')
          return
        }
      } else if (this.command === '2') {
        if (!this.batchValue) {
          this.$message.error('修改值不能为空!')
          return
        }
        let reg = /^[1-9]\d*$/
        if (!reg.test(this.batchValue)) {
          this.$message.error('修改值只能为正整数!')
          return false
        }
      } else if (this.command === '3') {
        jsondata.value = 0
      } else if (this.command === '4') {
        jsondata.type = '3'
        jsondata.value = 1
      }
      console.log(jsondata)
      HTTPServer.batchModifyTrialUser(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '操作成功！',
          type: 'success'
        })
        this.queryTrialUserList()
        this.batchDialog = false
        this.dialogStatus = false
      })
    },
    /** 获取 组件管理 */
    getComponentManageList () {
      var jsondata = {'pageNum': 1, 'pageSize': 9999, 'searchContent': ''}
      HTTPServer.getComponentManageList(jsondata, 'Loading').then((res) => {
        this.componentData = res.dataList
      })
    },
    /** 获取试用客户 */
    queryTrialUserList () {
      var jsondata = {'pageNum': this.pageNum, 'pageSize': this.pageSize, 'keyWord': this.searchValue}
      HTTPServer.queryTrialUserList(jsondata, 'Loading').then((res) => {
        this.tableList = res.dataList
        var pageInfo = res.pageInfo
        this.tableTotal = pageInfo.totalRows
        if (this.dialogCusDetail) {
          this.tableList.map((item) => {
            if (this.customerDetail.id === item.id) {
              this.customerDetail = Object.assign({}, this.customerDetail, item)
            }
          })
        }
      })
    },
    /** 列表选择 */
    handleSelectionChange (val) {
      this.multipleSelection = val
      this.disabled = (this.multipleSelection.length === 0)
    },
    /** 显示每页条数 */
    handleSizeChange (val) {
      this.pageSize = val
      this.pageNum = 1
      this.queryTrialUserList()
    },
    /** 跳转第几页 */
    handleCurrentChange (val) {
      this.pageNum = val
      this.queryTrialUserList()
    },
    /** 搜索 */
    search () {
      this.searchValue = JSON.parse(JSON.stringify(this.searchInput))
      this.pageNum = 1
      this.pageSize = 20
      this.queryTrialUserList()
    },
    /** 新增客户弹窗 */
    AddDialog () {
      this.dialogAdd = true
      this.customerDetail = {addType: 1}
    },
    /** 新增保存试用客户 */
    saveTrialUser (jsondata) {
      HTTPServer.saveTrialUser(jsondata, 'Loading').then((res) => {
        this.$message({
          showClose: true,
          message: '保存成功！',
          type: 'success'
        })
        this.pageNum = 1
        this.searchValue = ''
        this.dialogAdd = false
        this.queryTrialUserList()
      })
    },
    /** 进入客户详情 */
    rowClick (row, event, column) {
      this.customerDetail = row
      this.dialogCusDetail = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/customer/trial.vue